export default __webpack_public_path__ + "static/ingles-f9514faca2a262ad6c45a97e7a65eaf8.png";